'use client';
import SXMLink from '@/shared-components/SXMLink';
import { Button, ButtonProps } from '@/ui-components/atoms/Button/Button';
import styles from './chatlink.module.scss';
import { LinkInfoItem } from '@/components/molecules/LinkInfoCard';

interface Props {
    type: LinkType | undefined;
    variant?: ButtonProps['variant'];
    colorSet?: ButtonProps['colorSet'];
    bgColor?: string;
    text: string | undefined;
    iconUrl?: string;
    iconWidth?: number;
    iconHeight?: number;
}

export default function ChatLink({
    type,
    variant = 'primary',
    colorSet,
    text,
    iconUrl,
    iconHeight,
    iconWidth,
}: Props): React.JSX.Element | null {
    const openChat = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        const clientWindow = window as BrowserWindow;
        clientWindow?.sierraSXM?.openChatModal();
    };

    if (!type) return null;

    if (type.indexOf('CTA') >= 0) {
        return (
            <div className={styles.chatSpacing}>
                <Button type="button" variant={variant} colorSet={colorSet} onClick={openChat} fitting="hug-contents">
                    {text}
                </Button>
            </div>
        );
    }

    if (type === 'Text') {
        return (
            <SXMLink href="" onClick={openChat}>
                {text}
            </SXMLink>
        );
    }

    if (type === 'LinkInfoCard') {
        return (
            <LinkInfoItem
                link={{
                    link_text: text,
                }}
                disabled={false}
                onClick={openChat}
                icon={{ url: iconUrl, width: iconWidth, height: iconHeight }}
            />
        );
    }

    return null;
}
